import { useCallback, useRef, useState } from "react";
import ConfirmModal from "./index";

const useConfirmDialog = (options = {}) => {
  const {
    confirmLabel = "Confirmar",
    cancelLabel = "Cancelar",
    confirmClassName = "",
    cancelClassName = "",
  } = options;
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const resolverRef = useRef(null);

  const confirm = useCallback((msg) => {
    setMessage(msg || "Tem certeza?");
    setOpen(true);
    return new Promise((resolve) => {
      resolverRef.current = resolve;
    });
  }, []);

  const handleConfirm = useCallback(() => {
    setOpen(false);
    if (resolverRef.current) resolverRef.current(true);
    resolverRef.current = null;
  }, []);

  const handleCancel = useCallback(() => {
    setOpen(false);
    if (resolverRef.current) resolverRef.current(false);
    resolverRef.current = null;
  }, []);

  const ConfirmModalWrapper = useCallback(() => (
    <ConfirmModal
      open={open}
      message={message}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      loading={false}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      confirmClassName={confirmClassName}
      cancelClassName={cancelClassName}
    />
  ), [open, message, handleConfirm, handleCancel, confirmLabel, cancelLabel, confirmClassName, cancelClassName]);

  return { confirm, ConfirmModal: ConfirmModalWrapper };
};

export default useConfirmDialog;
